/* tslint:disable */
/* eslint-disable */
export enum ServiceType {
  DINE_IN = 'DineIn',
  BRING_TO_TABLE = 'BringToTable',
  PICKUP = 'Pickup',
  DRIVE_THRU = 'DriveThru',
  CURBSIDE = 'Curbside',
  DELIVERY_BY_CHANNEL = 'DeliveryByChannel',
  DELIVERY_BY_RESTAURANT = 'DeliveryByRestaurant',
}